import styled from '@emotion/styled';

const FooterBar = styled.footer`
  border-top: 1px solid var(--color-border);
  padding: var(--space-md) var(--space-lg);
`;

const Inner = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-md);
  justify-content: space-between;
  margin: 0 auto;
  max-width: var(--max-width-app);
`;

const Label = styled.span`
  color: var(--color-text-muted);
  font-family: var(--font-ui);
  font-size: var(--font-size-label);
  letter-spacing: var(--letter-spacing-label);
`;

const Kbd = styled.kbd`
  background: var(--color-bg-subtle);
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-sm);
  font-family: var(--font-display);
  font-size: 0.65rem;
  padding: 1px 6px;
`;

export default function Footer() {
  return (
    <FooterBar aria-label="Site footer">
      <Inner>
        <Label>cryotype &mdash; free online typing test</Label>
        <Label>
          press <Kbd>tab</Kbd> to restart
        </Label>
      </Inner>
    </FooterBar>
  );
}
